import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ClearOutlined } from '@ant-design/icons';
import ListPage from '@components/common/layout/ListPage';
import { DEFAULT_TABLE_ITEM_SIZE_LARGE } from '@constants';
import apiConfig from '@constants/apiConfig';
import useListBase from '@hooks/useListBase';
import useTranslate from '@hooks/useTranslate';
import { BaseTable, TextField } from '@itz/react-cms-element';
import { commonMessage } from '@locales/intl';
import { IconSearch } from '@tabler/icons-react';
import { Button, Col, Flex, Form, Row } from 'antd';


const BeilageModal = ({ handleSelectBeilageItem, currentRestaurant }) => {
    const translate = useTranslate();
    const [form] = Form.useForm();
    const [searchValues, setSearchValues] = useState({ name: '' });

    const handleSearch = () => {
        setPagination((prev) => ({ ...prev, current: 1 }));
        mixinFuncs.getList();
    };

    const handleCancelSearch = () => {
        form.resetFields();
        setPagination((prev) => ({ ...prev, current: 1 }));
        mixinFuncs.getList();
    };

    const columns = [
        { title: translate.formatMessage(commonMessage.name), dataIndex: 'name' },
        {
            title: translate.formatMessage(commonMessage.action),
            className: 'text-center',
            width: '130px',
            render: (dataRow) => (
                <span>
                    <Button type="primary" size="small" onClick={() => handleSelectBeilageItem(dataRow)}>
                        {translate.formatMessage(commonMessage.select)}
                    </Button>
                </span>
            ),
        },
    ];

    const {
        data,
        mixinFuncs,
        queryFilter,
        loading: listLoading,
        pagination,
        setPagination,
    } = useListBase({
        apiConfig: apiConfig.beilage,
        options: {
            pageSize: DEFAULT_TABLE_ITEM_SIZE_LARGE,
        },
        override: (funcs) => {
            funcs.mappingData = (response) => {
                if (response.result === true) {
                    return {
                        data: response.data.content,
                        total: response.data.totalElements,
                    };
                }
            };
            funcs.prepareGetListParams = () => {
                const formValues = form.getFieldsValue();
                const currentPage = parseInt(queryFilter.page) || pagination.current;
                const params = {
                    ...formValues,
                    page: currentPage - 1 >= 0 ? currentPage - 1 : 0,
                    size: DEFAULT_TABLE_ITEM_SIZE_LARGE,
                };
                return params;
            };
        },
    });

    return (
        <div>
            <ListPage
                style={{ border: 'none' }}
                searchForm={
                    <>
                        <Form form={form} initialValues={{ phone: '', email: '' }}>
                            <Row gutter={10}>
                                <Col span={5}>
                                    <TextField
                                        name="name"
                                        placeholder={translate.formatMessage(commonMessage.name)}
                                        fieldProps={{
                                            onChange: (e) => {
                                                setSearchValues({
                                                    ...searchValues,
                                                    phone: e.target.value,
                                                });
                                            },
                                        }}
                                    />
                                </Col>
                                <Col span={8}>
                                    <Flex gap="10px">
                                        <Button type="primary" onClick={handleSearch}>
                                            <IconSearch style={{ width: '18px', height: '18px' }} />
                                            {translate.formatMessage(commonMessage.search)}
                                        </Button>
                                        <Button onClick={handleCancelSearch}>
                                            <ClearOutlined style={{ width: '18px', height: '18px' }} />
                                            {translate.formatMessage(commonMessage.clear)}
                                        </Button>
                                    </Flex>
                                </Col>
                            </Row>
                        </Form>
                    </>
                }
                baseTable={
                    <BaseTable
                        columns={columns}
                        rowKey={(record) => record.id}
                        dataSource={data}
                        pagination={pagination}
                        onChange={mixinFuncs.changePagination}
                    />
                }
            />
        </div>
    );
};

export default BeilageModal;